import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { CR_CONSTANTS } from './constants';

export const Ng1ConstantsModule = angular
  .module('control-room.angular.constants', [])
  .factory('crConstants', downgradeInjectable(CR_CONSTANTS));
